module.exports = __webpack_public_path__ + "static/system-0233e21dcbbeb3f11c136aa3e75606b0.jpg";